import api from '@/api'
import _ from 'lodash'
export default {
  getRev(context, payload) {
    return api.rev
      .getById(payload.organizationId, payload.revId)
      .then(({ data: rev }) => {
        context.commit('SET_REV', { rev })

        return rev
      })
  },

  async translateRev(
    context,
    { organizationId, revId, targetLanguage, fieldsToTranslate }
  ) {
    const { data: rev } = await api.rev.getById(organizationId, revId)

    const translatedRev = Object.assign({}, rev)

    for (const field of fieldsToTranslate) {
      if (!_.get(rev, field)) continue
      const translatedField = await api.translate.text(
        organizationId,
        _.get(rev, field),
        targetLanguage
      )

      _.set(translatedRev, field, translatedField.data.translatedText)
    }

    context.commit('SET_REV', { rev: translatedRev })
    return translatedRev
  },

  async getRevChallenge(context, { organizationId, revId }) {
    const challengeResponse = await api.challenge.getChallengesFromRev(
      'revs',
      organizationId,
      revId
    )
    const challenge = challengeResponse.data?.[0] ?? null
    context.commit('SET_CHALLENGE', {
      challenge: {
        name: challenge?.name ?? '',
      },
    })

    return challenge
  },
}
